var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "quick-play-layer" }, [
    _c("button", {
      staticClass: "quick-play-backdrop",
      attrs: { type: "button", "aria-label": _vm.$t("Close Quick Play") },
      on: {
        click: function ($event) {
          return _vm.$emit("close")
        },
      },
    }),
    _c(
      "section",
      {
        staticClass: "quick-play-sheet",
        attrs: {
          role: "dialog",
          "aria-modal": "true",
          "aria-label": _vm.$t("Quick Play"),
        },
      },
      [
        _c(
          "TaiXiuBoardLayout",
          [
            _c(
              "BetBoard",
              _vm._g(
                _vm._b(
                  { attrs: { compact: "" } },
                  "BetBoard",
                  _vm.$attrs,
                  false
                ),
                _vm.$listeners
              )
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }